import React from 'react';
import {
  useModifyQuestionReply,
  useBlockSpotifyUserFromQuestion,
} from 'hooks/useInteractivityPolls';

export function ReplyActions({
  episodeId,
  questionId,
  replyId,
  spotifyUserId,
  isPinned,
}: {
  episodeId: string;
  questionId: number;
  replyId: string;
  spotifyUserId: string;
  isPinned: boolean;
}) {
  const { modifyQuestionReply, status: pinStatus } = useModifyQuestionReply();
  const {
    blockSpotifyUserFromQuestion,
    status: blockStatus,
  } = useBlockSpotifyUserFromQuestion();
  const pinReply = () =>
    modifyQuestionReply({
      episodeId,
      questionId,
      replyId,
      spotifyUserId,
      action: 'feature',
    });
  const unPinReply = () =>
    modifyQuestionReply({
      episodeId,
      questionId,
      replyId,
      spotifyUserId,
      action: 'unfeature',
    });
  const blockUser = () =>
    blockSpotifyUserFromQuestion({
      episodeId,
      spotifyUserId,
    });
  return (
    <div>
      {isPinned ? (
        <span onClick={unPinReply}>
          {pinStatus === 'loading' ? 'Unpinning ...' : 'Unpin'}
        </span>
      ) : (
        <span onClick={pinReply}>
          {pinStatus === 'loading' ? 'Pinning ...' : 'Pin'}
        </span>
      )}
      {' | '}
      <span onClick={blockUser}>
        {blockStatus === 'loading' ? 'Blocking ...' : 'Block user'}
      </span>
    </div>
  );
}
